import { useKeycloak } from "@/app/hook/use-keycloak";
import { useLoader } from "@/app/hook/use-loader";
import { useMenu } from "@/app/hook/use-menu";
import { useProfile } from "@/app/hook/use-profile";
import { Divider, Menu, MenuProps } from "@/base/components/index";
import { ArrowRightLineIcon, CheckIcon } from "@/base/static/index";
import { AccountItemType, MenuItemType } from "@/schemas/index";
import { useCallback, useMemo } from "react";
import { renderMenuItems } from "../../utils/render-menu-items";
import { HeaderNavigateAvatar } from "./header-navigate-avatar";
import { useHeaderNavigateStyles } from "./header-navigate.styles";

export const HeaderNavigateUserMenu = () => {
  const { styles } = useHeaderNavigateStyles();
  const { setLoader } = useLoader();
  const userMenuItems = useMenu("user");
  const { logout } = useKeycloak();
  const { accounts, profile, changeCurrentAccount } = useProfile();

  const handleChangeAccount = async (account: AccountItemType) => {
    setLoader(true);
    const result = await changeCurrentAccount(account);

    if (result) {
      window.location.reload();
    }
    setLoader(false);
  };

  const handleLogout = useCallback(async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Logout failed:", error);
    }
  }, []);

  const menuItems: any = useMemo(() => {
    const menuItems: MenuItemType[] = renderMenuItems([
      ...(userMenuItems || []),
    ]);

    const menuAccountItems: MenuProps["items"] =
      accounts?.map((account) => ({
        key: account.Id,
        label: account.Name,
        onClick: () => handleChangeAccount(account),
        disabled: profile?.AccountId === account.Id,
        className: styles.menuItemAccount,
        icon:
          profile?.AccountId === account.Id ? (
            <CheckIcon />
          ) : (
            <ArrowRightLineIcon />
          ),
      })) || [];

    const getItemDivider = (text?: any) => ({
      disabled: true,
      className: styles.menuItemDivider,
      label: <Divider className={styles.menuItemDividerCmp}>{text}</Divider>,
    });

    return [
      {
        key: "user",
        icon: <HeaderNavigateAvatar />,
        children: [
          ...menuItems.reduce((accumulator: any, currentValue: any) => {
            if (currentValue.key === "user.profile") {
              const items = [...accumulator, currentValue];

              if (menuAccountItems?.length > 1) {
                items.push(
                  getItemDivider("Accounts"),
                  ...menuAccountItems,
                  getItemDivider(),
                );
              }

              return items;
            }

            if (currentValue.key === "support.logout") {
              return [
                ...accumulator,
                {
                  ...currentValue,
                  onClick: handleLogout,
                },
              ];
            }
            return [...accumulator, currentValue];
          }, []),
        ],
      },
    ];
  }, [userMenuItems, accounts, handleLogout]);

  return (
    <div className={styles.userMenu}>
      <Menu
        theme="dark"
        mode="horizontal"
        items={menuItems}
        selectable={false}
        className={styles.menuComponent}
      />
    </div>
  );
};
